import {
    GET_LICENSE_PURCHASE_PROPERTIES,
    LICENSE_PURCHASE_PROPERTIES,
    ADD_LICENSE_PURCHASE_PROPERTY,
    DELETE_LICENSE_PURCHASE_PROPERTIY,
    LICENSE_PURCHASE_PROPERTIES_MESSAGE,
    SHOW_LOADING,
    HIDE_LOADING,
    SET_ADD_EDIT,
    LICENSE_PRICING_LIST,
    LICENSE_PRICING_VALUE_LIST,
    LICENSE_PRICE_BACK
  } from "redux/constants/licensePricing";
  import { APP_PREFIX_PATH } from "configs/AppConfig";
  
  const initState = {
    loading: true,
    licensePurchaseProperties: [],
    licensePricingList:[],
    licensePricingValues:[],
    licensePurchaseProperty: {},
    message: "",
    showMessage: false,
    redirect: "",
    allowRedirect: false,
    status: 0,
    addEditValue: false,
    permissions : localStorage.getItem("permissions")!==""?JSON.parse(localStorage.getItem("permissions")):"",
  };
  
  const licensePricing = (state = initState, action) => {
    switch (action?.type) {
      case LICENSE_PURCHASE_PROPERTIES:
        return {
          ...state,
          licensePurchaseProperties: action.licensePurchaseProperties,
          allowRedirect: false,
          loading: false,
          message: "",
        };
        case LICENSE_PRICING_LIST:
          return {
            ...state,
            licensePricingList: action.licensePricingList,
            allowRedirect: false,
            loading: false,
            message: "",
          };
        case LICENSE_PRICING_VALUE_LIST:
          return {
            ...state,
            licensePricingValues: action.licensePricingValues,
            allowRedirect: false,
            loading: false,
            message: "",
          };
      case LICENSE_PURCHASE_PROPERTIES_MESSAGE:
        return {
          ...state,
          message: messageRead(action),
          status: action?.response?.status,
          showMessage: true,
          loading: false,
        };
        // case LICENSE_PRICE_BACK:{
        //   return {
        //     ...state,
        //     back: true,
        //   };
       // }
      case SHOW_LOADING: {
        return {
          ...state,
          loading: true,
        };
      }
      case HIDE_LOADING: {
        return {
          ...state,
          loading: false,
        };
      }
      case SET_ADD_EDIT:
        return {
          ...state,
          addEditValue: action.addEditValue,
          loading: false,
          appRolePermissions: [],
        };
      default:
        return state;
    }
  };
  
  const messageRead=(action)=>{
    if(action?.response?.status==401 || action?.response?.response?.status){
      return "Unauthorized"
    }
      if(action?.response && action?.response?.response && action?.response?.response?.data && action?.response?.response?.message){
       return action?.response?.response?.data?.message;
      }else if(action?.response && action?.response?.data && action?.response?.data?.message){
          return action?.response?.data?.message;
      }else if(action?.response && action?.response?.data && action?.response?.data?.message){
          return action?.response?.data?.message;
      }else if(action?.data?.message){
          return action?.data?.message;
      }else if(action?.data){
          return action?.data;
      }else{
          return "something went wrong"
      }
  }
  
  export default licensePricing;
  